
import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { IShapeDrawable } from "../../../../../domain/document/items";
import { Point, Size, Rectangle, PaintStyle, TextureKinds, LineStyle, LineKinds } from "../../../../../domain/drawing";

@Component({
})
export default class ShapeDrawableMixin extends Mixins() {
  readPropertyOrDefault: <T>(reader: (source: IShapeDrawable) => T, defaultValue: T) => T;
  privateId: number;
  rectangle: Rectangle;

  get lineStyle(): LineStyle {
    return this.readPropertyOrDefault(s => s.lineStyle, null);
  }

  get shapeStyleProperties() {
    return {
      fill: this.textureUrl,
      stroke: this.lineStyle.color.value,
      strokeWidth: this.lineStyle.width,
      strokeDasharray: (this.lineStyle.kind === LineKinds.Dotted) ? "3" : "0",
      pointerEvents: "visiblePainted",
    };
  }

  get additionalTextureShapeStyleProperties() {
    return {
      fill: this.additionalTextureUrl,
      stroke: "none",
      pointerEvents: "visiblePainted",
    };
  }

  toStrings(points: Point[]): string[] {
    return Enumerable.from(points)
      .select(p => this.toString(p))
      .toArray();
  }

  /**
   * objectのtoStringをoverrideしているので注意が必要
   */
  toString(point: Point): string {
    return !point
      ? ""
      : point.x + "," + point.y;
  }

  get paintStyle(): PaintStyle {
    return this.readPropertyOrDefault(s => s.paintStyle, null);
  }

  get textureColor() {
    return this.paintStyle.color.value;
  }

  get texturePatternPrefix(): string {
    return "TexturePattern_" + this.privateId + "_";
  }

  get textureKind(): TextureKinds {
    return !this.paintStyle.kind
      ? TextureKinds.None
      : this.paintStyle.kind;
  }

  get additionalTextureKind(): TextureKinds {
    return !this.paintStyle.additionalTextureKind
      ? TextureKinds.None
      : this.paintStyle.additionalTextureKind;
  }

  get textureUrl() {
    return (this.textureKind === TextureKinds.None)
      ? "none"
      : "url(#" + this.texturePatternPrefix + this.textureKind + ")";
  }

  get additionalTextureUrl() {
    return (this.additionalTextureKind === TextureKinds.None)
      ? "none"
      : "url(#" + this.texturePatternPrefix + this.additionalTextureKind + ")";
  }

  get draggableShapeStyleProperties() {
    return {
      fill: "none",           // none.(transparentだと描画はされるため、pointerEvents対象になってしまう.)
      stroke: "transparent",  // transparentで描画する事で、pointerEvents対象とする.)
      strokeWidth: this.draggableStrokeWidth,
      strokeDasharray: (this.lineStyle.kind === LineKinds.Dotted) ? "3" : "0",
      pointerEvents: "visiblePainted",
    };
  }

  get draggableStrokeWidth(): number {
    return Math.max(this.lineStyle.width, 4);
  }

  get drawerRectangle(): Rectangle {
    return new Rectangle(
      this.rectangle.topLeft,
      new Size(Math.max(this.rectangle.width, 1), Math.max(this.rectangle.height, 1)));
  }

  get drawerStyleProperties() {
    return {
      position: "absolute",
      top: this.drawerRectangle.x + "px",
      left: this.drawerRectangle.y + "px",
      width: this.drawerRectangle.width + "px",
      height: this.drawerRectangle.height + "px",
    };
  }
}
